<template>
    <div class="show_details padding-20 bgc box-shadow">
        <div class="top">
            <p>提现详情</p>
        </div>
        <div class="info_box">
            <div class="info_item_box">
                <span>交易流水：</span>
                <span>{{data.orderno}}</span>
            </div>
            <div class="info_item_box">
                <span>提款金额（元）：</span>
                <span>{{data.cashmoney}}</span>
            </div>
            <div class="info_item_box">
                <span>手续费（元）：</span>
                <span>{{data.zzfee}}</span>
            </div>
            <div class="info_item_box">
                <span>实际到账（元）：</span>
                <span>{{data.cashaccountmoney}}</span>
            </div>
            <div class="info_item_box">
                <span>处理时间：</span>
                <span>{{data.finishtime}}</span>
            </div>
            <div class="info_item_box">
                <span>处理状态：</span>
                <span>{{data.statustext}}</span>
            </div>
            <div class="info_item_box">
                <span>审核说明：</span>
                <span>{{data.authdesp}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {withdrawListInfo} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'ShowDetails',
    data() {
        return {
            hostinnerid: null,
            data: {
                orderno: '',
                cashmoney: '',
                finishtime: '',
                status: 0
            }
        }
    },
    mounted() {
        this.hostinnerid = this.user.hostinnerid
        this.getWithdrawList()
    },
    methods: {
        // 获取提现详情data
        getWithdrawList() {
            this.setLoading(true)
            withdrawListInfo({
                url: `/api/admin/order/withdrawList/${this.$route.query.orderno}`,
                data: {
                    orderno: this.$route.query.orderno
                },
                success: data => {
                    console.log('获取提现详情data:', data)
                    this.setLoading(false)
                    this.data = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {}
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .show_details {
        padding-bottom: 50px;
        .top{
            margin-top: 10px;
            p{
                padding-left: 10px;
                border-left: 2px solid #409eff;
                font-size: 16px;
                font-family: PingFangSC-Medium;
                font-weight: bold;
                color: rgba(48, 49, 51, 1);
            }
        }
        .info_box{
            margin-top: 30px;
            .info_item_box{
                margin-top: 30px;
                span:nth-of-type(1){
                    color: #203133;
                    font-weight: 500;
                }
                span:nth-of-type(2){
                    color:rgba(96,98,102,1);
                }
            }
            .info_item_box:nth-of-type(1){
                margin-top: 0px;
            }
        }
    }
</style>